<template>
  <el-config-provider :locale="locale">
    <div id="operate">
      <router-view />
    </div>
  </el-config-provider>
</template>
<script>
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const locale = ref(zhCn);
    return {
      locale,
    };
  },
});
</script>
<style lang="less">
#operate {
  width: 100%;
  height: 100%;
}
</style>
